import { UseMutateFunction } from 'react-query';
import { FetchResponse, Pagination } from 'types/common';
import { Report } from 'types/report';

type Params = {};

export enum Tabs {
  ALL = 0,
  IN_REVIEW = 1,
  READY_FOR_IMPACT = 2,
  READY_FOR_INVOICE = 3,
  DONE = 4,
  ARCHIVE = 5,
}

export type HarvestSummaryProps = {};

export type HarvestSummaryViewProps = {
  pagination: Pagination;
  tabIdx: number;
  isLoading: boolean;
  status?: number;
  sites?: string[];
  accountManagers?: string[];
  sentToClient?: boolean;
  feeAdjustmentTypes?: string[];
  endDate?: Date;
  startDate?: Date;
  counts: Report[];
  setSites: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  setAccountManagers: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
  setSentToClient: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  setFeeAdjustmentTypes: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
  setEndDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  setStartDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  isSuccess: boolean;
  onRefresh: () => void;
  onTabChange: (index: number) => void;
  csvRef: React.MutableRefObject<any>;
  mutateCsv: UseMutateFunction;
  isArchiveTab?: boolean;
  sortHandler: (field: string) => void;
  reportCounts: Record<string, number>;
  /** Raw text in the search box. */
  searchInput: string;
  onSearchChange: (value: string) => void;
};

export type HarvestSummaryTabProps = {
  pagination: Pagination;
  counts: Report[];
  isLoading: boolean;
  isArchived?: boolean;
  sortHandler: (field: string) => void;
};

export type HarvestSummaryPdfGeneratorProps = {
  fileName: string;
  documentTemplate: React.ElementType;
  data: any;
  type?: string;
  secondFileName?: string | undefined;
  secondDocumentTemplate?: React.ElementType | undefined;
  useDummyDataOverride?: boolean;
};
